"use client";

import React from "react";
import { Phone, Users, ClipboardCheck, UserPlus, HeartHandshake, RefreshCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const intakeSteps = [{
  title: "Aanmelding en eerste contact",
  description: "U of uw verwijzer neemt contact met ons op. We plannen op korte termijn een afspraak in om uw situatie te bespreken.",
  icon: Phone
}, {
  title: "Kennismaking en inventarisatie",
  description: "Tijdens een persoonlijk gesprek bij u thuis brengen we uw zorgbehoeften, wensen en persoonlijke achtergrond in kaart.",
  icon: Users
}, {
  title: "Afstemming van passende ondersteuning",
  description: "Op basis van de kennismaking stellen we een zorgplan op maat op, volledig afgestemd op uw specifieke situatie.",
  icon: ClipboardCheck
}, {
  title: "Inzet van zorgverleners",
  description: "We selecteren een vaste, gediplomeerde zorgprofessional die goed bij u past, voor optimaal vertrouwen en continuïteit.",
  icon: UserPlus
}, {
  title: "Start van de zorg",
  description: "De afgesproken zorg en ondersteuning gaat van start, met respect voor uw gewoonten, religie en cultuur.",
  icon: HeartHandshake
}, {
  title: "Evaluatie en afstemming",
  description: "We evalueren regelmatig of de geboden zorg nog passend is en sturen bij waar nodig, in overleg met u en uw naasten.",
  icon: RefreshCcw
}];
export default function DuidelijkeEnZorgvuldigeeZorg() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="duidelijke-en-zorgvuldigee-zorg" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 max-w-[700px]">
        <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-primary mb-4">
              Duidelijke en zorgvuldige zorg
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed">
              Bij CuraNova Zorg hechten we veel waarde aan transparantie en een zorgvuldig proces. 
              We leggen u graag stap voor stap uit wat u kunt verwachten, van de eerste kennismaking 
              tot de start van de zorg.
            </p>
          </div>

          <div className="space-y-8">
            {intakeSteps.map((step, i) => {
            const Icon = step.icon;
            return <div key={i} data-index={i} className="flex gap-4 md:gap-6 group">
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                      <Icon className="w-6 h-6" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-foreground mb-2">
                      {i + 1}. {step.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>

          <div className="mt-16 text-center">
            <p className="text-foreground font-medium mb-6">
              Heeft u vragen over ons intakeproces of wilt u een situatie bespreken?
            </p>
            <Button asChild size="lg" className="rounded-full px-8">
              <Link to="/ContactPage">
                Neem contact met ons op
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}